<template>
    <div class="print-page">
      <div class="header">
        <div class="document-meta">
          <div><strong>문서 ID:</strong> {{ order.id }}</div>
          <div><strong>발주일:</strong> {{ formatDate(order.order_date) }}</div>
        </div>
      </div>
  
      <h2 class="title">{{ isRaw ? '원자재 발주서' : '부자재 발주서' }}</h2>
      <ApprovalTable :approval-line="order.approvals" />
      <OrderInfoTable :order="order" :formatDate="formatDate" />
      <RawMaterialTable v-if="isRaw" :items="order.items" />
      <SubMaterialTable v-else :items="order.items" :totalPrice="totalPrice" />
    </div>
  </template>

  
  <script setup>
  import { ref, onMounted, computed } from 'vue'
  import { useRoute } from 'vue-router'
  import axiosInstance from '@/api/axios'

  import ApprovalTable from '@/components/ApprovalTable.vue'
  import OrderInfoTable from '@/components/OrderInfoTable.vue'
  import RawMaterialTable from '@/components/RawMaterialTable.vue'
  import SubMaterialTable from '@/components/SubMaterialTable.vue'
  
  const route = useRoute()
  const order = ref({})
  const totalPrice = ref(0)
  const isRaw = computed(() => order.value.material_type === 'raw')
  
  onMounted(async () => {
    const { data } = await axiosInstance.get(`material-orders/${route.params.id}/`)
    order.value = data
    /*
    setTimeout(() => {
      window.print()
      window.close()
    }, 1000) // <- 500 → 1000으로 변경
    */

  })
  
  const formatDate = (dateStr) => {
    if (!dateStr) return ''
    return new Date(dateStr).toLocaleDateString('ko-KR')
  }
  </script>
  
  <style scoped>
  .print-page {
    padding: 24px;
    font-size: 13px;
    color: #111;
    width: 210mm;
    min-height: 297mm;
    box-sizing: border-box;
    font-family: 'Noto Sans KR', sans-serif;
  }
  
  .header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 16px;
  }
  
  .company-logo {
    height: 60px;
  }
  
  .document-meta {
    text-align: right;
    font-size: 12px;
    line-height: 1.4;
  }
  
  .title {
    text-align: center;
    font-size: 20px;
    margin-bottom: 16px;
    font-weight: bold;
  }
  
  @media print {
    .print-page {
      box-shadow: none;
      padding: 20mm;
    }
  
    .company-logo {
      max-height: 50px;
    }
  }
  </style>
  